import { render } from "./NavBar2.vue?vue&type=template&id=485e027a"
import script from "./NavBar2.vue?vue&type=script&lang=js"
export * from "./NavBar2.vue?vue&type=script&lang=js"

import "./NavBar2.vue?vue&type=style&index=0&id=485e027a&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\21-century-edm-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__